import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createEvent as universalCreateEvent, cloneEvent as universalCloneEvent, updateEvent as universalUpdateEvent, publishDraftEvent as universalPublishDraftEvent, cancelEvent as universalCancelEvent, bulkCancelEventsByFilter as universalBulkCancelEventsByFilter, deleteEvent as universalDeleteEvent, bulkDeleteEventsByFilter as universalBulkDeleteEventsByFilter, queryEvents as universalQueryEvents, countEventsByStatus as universalCountEventsByStatus, listEventsByCategory as universalListEventsByCategory, getEvent as universalGetEvent, getEventBySlug as universalGetEventBySlug, findEvent as universalFindEvent, } from './events-v3-event.universal';
import { LocationType, SubdivisionSubdivisionType, RecurrenceStatusStatus, Status, RegistrationTypeType, RegistrationStatusStatus, ResponseType, TaxType, GuestTypeType, InitialRegistrationTypeType, InputControlType, ValueType, ConferenceTypeType, Type, RequestedFields, SortOrder, CommonSortOrder, Relation, LocationLocationType, SubdivisionType, EventsRecurrenceStatusStatus, EventStatus, EventType, RegistrationStatus, RsvpStatusOptions, EventsTaxType, VisitorType, ConferenceType, State, WebhookIdentityType, } from './events-v3-event.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.events.v3.event', module_name: 'wix-events.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createEvent: (event, options) => {
            const methodLogData = {
                method_name: 'createEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.createEvent',
            };
            return universalCreateEvent(event, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        cloneEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'cloneEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.cloneEvent',
            };
            return universalCloneEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateEvent: (_id, options) => {
            const methodLogData = {
                method_name: 'updateEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.updateEvent',
            };
            return universalUpdateEvent(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        publishDraftEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'publishDraftEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.publishDraftEvent',
            };
            return universalPublishDraftEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        cancelEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'cancelEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.cancelEvent',
            };
            return universalCancelEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCancelEventsByFilter: (options) => {
            const methodLogData = {
                method_name: 'bulkCancelEventsByFilter',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.bulkCancelEventsByFilter',
            };
            return universalBulkCancelEventsByFilter(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteEvent: (eventId) => {
            const methodLogData = {
                method_name: 'deleteEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.deleteEvent',
            };
            return universalDeleteEvent(eventId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteEventsByFilter: (options) => {
            const methodLogData = {
                method_name: 'bulkDeleteEventsByFilter',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.bulkDeleteEventsByFilter',
            };
            return universalBulkDeleteEventsByFilter(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryEvents: (options) => {
            const methodLogData = {
                method_name: 'queryEvents',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.queryEvents',
            };
            return universalQueryEvents(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countEventsByStatus: (options) => {
            const methodLogData = {
                method_name: 'countEventsByStatus',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.countEventsByStatus',
            };
            return universalCountEventsByStatus(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listEventsByCategory: (categoryId, options) => {
            const methodLogData = {
                method_name: 'listEventsByCategory',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.listEventsByCategory',
            };
            return universalListEventsByCategory(categoryId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'getEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.getEvent',
            };
            return universalGetEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getEventBySlug: (slug, options) => {
            const methodLogData = {
                method_name: 'getEventBySlug',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.getEventBySlug',
            };
            return universalGetEventBySlug(slug, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        findEvent: (options) => {
            const methodLogData = {
                method_name: 'findEvent',
                service_name: 'wix.events.events.v3.EventManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v3.event,environment=velo-frontend,method-fqn=wix.events.events.v3.EventManagement.findEvent',
            };
            return universalFindEvent(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        LocationType,
        SubdivisionSubdivisionType,
        RecurrenceStatusStatus,
        Status,
        RegistrationTypeType,
        RegistrationStatusStatus,
        ResponseType,
        TaxType,
        GuestTypeType,
        InitialRegistrationTypeType,
        InputControlType,
        ValueType,
        ConferenceTypeType,
        Type,
        RequestedFields,
        SortOrder,
        CommonSortOrder,
        Relation,
        LocationLocationType,
        SubdivisionType,
        EventsRecurrenceStatusStatus,
        EventStatus,
        EventType,
        RegistrationStatus,
        RsvpStatusOptions,
        EventsTaxType,
        VisitorType,
        ConferenceType,
        State,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=events-v3-event.frontend.js.map